import { createStorefrontApiClient } from "@shopify/storefront-api-client";

const CONTAINER = "shopify-section-product-recommendations";

const client = createStorefrontApiClient({
  storeDomain: "https://webstore-erbutler-com.myshopify.com",
  apiVersion: "2025-01",
  publicAccessToken: "3c11387011a3c1bb9af011bef5c5eda0",
});

import { makeType, initLog } from "../ui/core/base";

import { maybe, getWith, first } from "../ui/core/functions";

import { Stream } from "../ui/core/dispatcher-flyd";

import { modelChanged } from "../ui/components/common";

const getMetafield = (product, key) => {
  return product.metafields
    .filter((m) => m !== null)
    .filter((m) => m.key === key)
    .map((m) => m.value)
    .pop();
};

const getValue = (metafield) => {
  return metafields === null ? "" : metafield.value;
};

const proto = {
  name: "RelatedProducts",
  initLog,

  init() {
    return {
      cards: [],
      count: +1,
      header: false,
      hide: false,
    };
  },

  update(msg, model) {
    switch (msg.type) {
      case "remove-dom":
        model.hide = true;
        break;
      case "add-card":
        model.cards.push(msg.card);
        model.count++;
        break;
      case "add-product":
        model.cards.push(msg.card);
        model.count++;
        break;
      default:
        this.log.info("unhandled event:", msg.type, msg);
    }

    return model;
  },

  view(model) {
    if (model.hide === true) {
      document.getElementById(CONTAINER).remove();
    } else {
      if (model.header === false) {
        const header = `
      <header class="pt-l pb pb-xl-ns mb-l-ns">
        <h1 class="cross-heading fs-18 fs-5-ns ta-l ta-c-ns">Related Products</h1>
      </header>
      `;
        model.header = true;

        const headerParent = document.createElement("div");
        headerParent.innerHTML = header;
        const injected = [...headerParent.childNodes]
          .filter((n) => n.nodeType === 1)
          .first();

        this.dom.parentNode.appendChild(injected);
        this.dom.parentNode.appendChild(this.dom);
      }

      const parent = document.createElement("div");
      parent.innerHTML = model.cards.pop();
      const injected = [...parent.childNodes]
        .filter((n) => n.nodeType === 1)
        .first();

      this.dom.appendChild(injected);
    }

    return model;
  },

  initialize(dom) {
    this.initLog();
    this.dom = dom;

    let currentModel = this.init();

    this.eventStream = new Stream();

    this.eventStream.map((msg) => {
      let model = {
        ...currentModel,
      };
      model = this.update(msg, model);
      if (modelChanged(currentModel, model)) {
        model = this.view(model);
      }
      currentModel = model;
    });

    const tag = getWith("series")(dom.dataset);
    const vendor = getWith("collection")(dom.dataset);
    maybe((tag, vendor) => this.getRelated(tag, vendor))(tag, vendor);
  },

  card(product) {
    const media = product.media.nodes;
    const card = first(media.filter((i) => i.image.url.includes("_card")));
    const gcard = first(media.filter((i) => i.image.url.includes("_gcard")));
    const cover = first(media.filter((i) => i.image.url.includes("_cover")));
    const image = card || gcard || cover || media[0];

    const handle = `/products/${product.handle}`;

    const title = first(
      [
        getMetafield(product, "short_title"),
        getMetafield(product, "title"),
        product.title,
        "",
      ].filter((t) => t != undefined)
    );
// console.log(`title:`, title)
// console.table(product.metafields)
    const subtitle = first(
      [
        getMetafield(product, "short_subtitle"),
        getMetafield(product, "subtitle"),
        "",
      ].filter((t) => t != undefined)
    );

    const subtitleLine = maybe(
      (subtitle) =>
        `<h5 class="fs-14 fs-14-ns fs-12-md"><a href="${handle}">${subtitle}</a></h5></div>`
    )(subtitle);

    return `
    <div class="ui-card col-1 thumbnail fc-b-5 hc-b-8 lh-s">
      <a href="${handle}">
        <div class="card_image aspect_1 mb mb-l-ns">
          <div class="g_contain card_image_container1 bc-g2 bc-h-g3 b-a bg-center bg-cover lazyload" data-bgset="${image.image.url}"></div>
        </div>
      </a>

      <div class="card_text1 italic mb-xla lh-s1 lh-ns1 debug1 ">
        <h5 class="fs-14 fs-14-ns fs-12-md"><a href="${handle}">${title}</a></h5>
        ${subtitleLine}
    </div>
    `;
  },

  async getRelated(tag, vendor) {
    const vendorName = vendor.replace(" Collection", "");
    const query = `available_for_sale:true AND (tag:'${tag}' AND (tag:'${vendorName}' OR vendor:None))`;

    // product_title: metafield(namespace: "product", key: "product_title") { value }
    // product_subtitle: metafield(namespace: "product", key: "product_subtitle") { value }
    // short_title: metafield(namespace: "product", key: "short_title") { value }
    // short_subtitle: metafield(namespace: "product", key: "short_subtitle") { value }
    // abbreviated_title: metafield(namespace: "product", key: "abbreviated_title") { value }
    // abbreviated_subtitle: metafield(namespace: "product", key: "abbreviated_subtitle") { value }

    const productQuery = `
        query getProducts($first: Int, $query: String) {
            products(first: $first, query: $query) {
            nodes {
              id
              title
              tags
              vendor
              handle
              variants(first: 100) {
                nodes {
                  quantityAvailable
                }
              }
              metafields(
                identifiers: [{namespace: "product", key: "product_title"}, {namespace: "product", key: "product_subtitle"}, {namespace: "product", key: "short_title"}, {namespace: "product", key: "short_subtitle"}, {namespace: "product", key: "abbreviated_title"}, {namespace: "product", key: "abbreviated_subtitle"}]
              ) {
                key
                namespace
                value
              }
              media(first: 50) {
                nodes {
                  id
                  alt
                  ... on MediaImage {
                    image {
                      id
                      url
                    }
                  }
                }
              }
            }
          }
        }
        `;
    const hasInventory = (p) => {
      const variants = p.variants.nodes.filter((v) => v.quantityAvailable > 0);
      return variants.length > 0;
    };

    const { data, errors, extensions } = await client.request(productQuery, {
      variables: {
        first: 250,
        query: query,
      },
    });

    const records = data.products.nodes
      .filter((p) => p.handle !== this.dom.dataset.handle)
      .filter((p) => hasInventory(p));

    // const records2 = records.concat(this.testRecommendations(records))
    // const records2 = records
    // this.testRecommendations(records);

    // console.log(`products?:`, records2.length);

    if (records.length < 1) {
      this.eventStream.send({
        type: "remove-dom",
      });
    } else {
      records.forEach((p) => {
        this.eventStream.send({
          type: "add-product",
          card: this.card(p),
        });
      });
    }
  },

  async testRecommendations(products) {
    // console.log(`here`)

    const pids = [
      ...products.map((p) => {
        return p.id;
      }),
    ];
    console.log(`pids:`, pids)

    query = `
    query ($productId: ID!) {
      productRecommendations(productId: $productId) {
        id
        title
        tags
        vendor
        handle
        variants(first: 100) {
          nodes {
            quantityAvailable
          }
        }
        metafields(
          identifiers: [{namespace: "product", key: "product_title"}, {namespace: "product", key: "product_subtitle"}, {namespace: "product", key: "short_title"}, {namespace: "product", key: "short_subtitle"}, {namespace: "product", key: "abbreviated_title"}, {namespace: "product", key: "abbreviated_subtitle"}]
        ) {
          key
          namespace
          value
        }
        media(first: 50) {
          nodes {
            id
            alt
            ... on MediaImage {
              image {
                id
                url
              }
            }
          }
        }
      }
    }

    `;

    // console.log(`product`, products[0]);
    // console.log(`recommendations based on ${products[0].id}`);

    const { data, errors, extensions } = await client.request(query, {
      variables: {
        productId: products[0].id,
      },
    });
    // console.log(`errors:`, errors);
    // console.log(`recommendations:`, data.productRecommendations.filter((p) => !pids.includes(p.id)));

    return data.productRecommendations.filter((p) => !pids.includes(p.id));

  },
};

const RelatedProducts = makeType(proto);

export default RelatedProducts;

UI.register("related-products", RelatedProducts);
